export default __webpack_public_path__ + "static/media/mini_camera.a4850a38.svg";